import { Component, Input } from '@angular/core';
import { Task } from '../task';

@Component({
  selector: 'app-task-form',
  templateUrl: 'form.component.html',
})
export class TaskFormComponent {
  @Input() task: Task;
}
